import { render, staticRenderFns } from "./layout-main.vue?vue&type=template&id=1a3f7938"
import script from "./layout-main.vue?vue&type=script&lang=js"
export * from "./layout-main.vue?vue&type=script&lang=js"
import style0 from "./layout-main.vue?vue&type=style&index=0&id=1a3f7938&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports